import type { SVGProps } from 'react';

const SvgCricleQaLt = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox='0 0 24 24' fill='none' width='1em' height='1em' focusable='false' color='currentColor' {...props}>
    <path
      d='M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21Z'
      stroke='currentColor'
      strokeLinejoin='round'
    />
    <path
      d='M11.2849 14.7307C11.2111 14.7307 11.1495 14.6933 11.1495 14.581L11.1126 11.9002C11.1126 11.8005 11.1619 11.7506 11.2603 11.7506H11.7769C13.167 11.7506 13.8682 10.9277 13.8682 9.78055C13.8682 8.79551 13.1916 8.08479 12.0599 8.08479C11.0757 8.08479 10.4114 8.59601 10.0424 9.59352C10.0055 9.66833 9.94398 9.70574 9.87017 9.6808L9.09515 9.46883C9.00904 9.44389 8.98444 9.38155 9.00904 9.29426C9.48881 7.84788 10.6083 7 12.1337 7C13.8313 7 15 8.12219 15 9.69327C15 11.3017 13.9543 12.5736 12.1583 12.6858L12.1337 14.581C12.1337 14.6933 12.0722 14.7307 11.9984 14.7307H11.2849ZM11.6293 17C11.2234 17 10.8912 16.6883 10.8912 16.2519C10.8912 15.8155 11.2234 15.5287 11.6293 15.5287C12.0599 15.5287 12.392 15.8155 12.392 16.2519C12.392 16.6883 12.0599 17 11.6293 17Z'
      fill='currentColor'
    />
  </svg>
);
export default SvgCricleQaLt;
